import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-petrol" data-id="element-197">
      <div className="max-w-4xl mx-auto text-center" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-199">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gold/20 text-gold mb-6 border border-gold/30" data-id="element-200">
            <ShieldCheck size={40} data-id="element-201" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-cream mb-8" data-id="element-202">
            Garantía total de 7 días
          </h2>

          <div className="space-y-6 text-lg text-cream-light max-w-2xl mx-auto font-medium" data-id="element-203">
            <p data-id="element-204">
              Abrí los 5 tomos. Revisá los 4 recursos. Usalos en tu práctica de
              taller.
            </p>
            <p data-id="element-205">
              Si dentro de los primeros 7 días considerás que el material no
              cumple con lo que prometemos, te devolvemos el 100% de tu dinero.
            </p>
            <p className="text-gold" data-id="element-206">
              Sin formularios complicados. Sin preguntas incómodas. Sin demoras.
            </p>
            <p className="text-base font-normal opacity-90" data-id="element-207">
              El proceso es simple: contacto, solicitud, devolución completa en
              24 a 48 horas hábiles.
            </p>
            <p className="text-sm font-normal opacity-80 mt-8" data-id="element-208">
              Porque si el material no te da el valor que prometemos, no tiene
              sentido que te quedés con él ni nosotros con tu dinero.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}